import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-gray-900 border border-gray-200 shadow-lg rounded-lg",
          description: "text-gray-600",
          actionButton:
            "bg-pink-500 text-white",
          cancelButton:
            "bg-gray-100 text-gray-600",
          success: "border-green-200 bg-green-50",
          error: "border-red-200 bg-red-50",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
